import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnchorNav } from '@weezevent/nacre';
import TicketOfficeInformationsForm from './ticketOfficeInformationsForm';
import TicketOfficeOrderForm from './ticketOfficeOrderForm.js';
import TicketOfficeSettingsForm from './ticketOfficeSettingsForm';

export default function TicketOfficeParametersForm({ ticketOfficeSettingsForm, setTicketOfficeSettingsForm, setTicketOfficeSettingsFormObject, formErrors, hasModerationEnabled }) {
    const { t } = useTranslation();
    return (
        <AnchorNav
            rootId="main"
            items={[
                {
                    id: 'ticket-office-form-informations',
                    title: t('ticket.ticket_offices.parameters.form.informations.title')
                },
                {
                    id: 'ticket-office-form-order',
                    title: t('ticket.ticket_offices.parameters.form.order.title')
                },
                {
                    id: 'ticket-office-form-settings',
                    title: t('ticket.ticket_offices.parameters.form.settings.title')
                }
            ]}
        >
            <TicketOfficeInformationsForm
                setTicketOfficeSettingsForm={setTicketOfficeSettingsForm}
                ticketOfficeSettingsForm={ticketOfficeSettingsForm}
                setTicketOfficeSettingsFormObject={setTicketOfficeSettingsFormObject}
                formErrors={formErrors}
            />

            <TicketOfficeOrderForm
                setTicketOfficeSettingsForm={setTicketOfficeSettingsForm}
                ticketOfficeSettingsForm={ticketOfficeSettingsForm}
                hasModerationEnabled={hasModerationEnabled}
            />

            <TicketOfficeSettingsForm setTicketOfficeSettingsForm={setTicketOfficeSettingsForm} ticketOfficeSettingsForm={ticketOfficeSettingsForm} />
        </AnchorNav>
    );
}
